module.exports = __webpack_public_path__ + "img/75.2995daad.jpg";